import { Extension } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import StarterKit from '@tiptap/starter-kit';
import { Markdown } from 'tiptap-markdown';

const DisableUnsupportedShortcuts = Extension.create({
  name: 'disableUnsupportedShortcuts',
  addKeyboardShortcuts() {
    return {
      'Mod-u': () => true,
      'Mod-U': () => true,
    };
  },
});

export const RICH_TEXT_EXTENSIONS = [
  StarterKit.configure({
    heading: { levels: [2, 3] },
    bulletList: {},
    orderedList: {},
    strike: {},
    bold: {},
    italic: {},
    hardBreak: {},
    code: false,
    codeBlock: false,
    blockquote: false,
    horizontalRule: false,
    link: false,
  }),
  Link.configure({
    openOnClick: false,
    autolink: false,
    linkOnPaste: false,
    protocols: ['http', 'https', 'mailto'],
    HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' },
  }),
  Markdown.configure({
    html: false,
    breaks: false,
    linkify: false,
    transformPastedText: true,
    transformCopiedText: true,
  }),
  DisableUnsupportedShortcuts,
];

export const buildExtensions = ({ placeholder }: { placeholder?: string } = {}) => [
  ...RICH_TEXT_EXTENSIONS,
  ...(placeholder ? [Placeholder.configure({ placeholder })] : []),
];
